import React from "react";
import footerLogo from "../../assets/icons/logoEasyvoteBlue1@3x.png";
import "./styles.scss";

const Footer = () => (
  <div className="footer">
    <img className="logo" src={footerLogo} alt="footer" />
  </div>
);

export default Footer;
